import EquipmentInventoryEditWorkspace from "components/Financial/EquipmentInventoryEditWorkspace";
import EquipmentInventoryWorkspace from "components/Financial/EquipmentInventoryWorkspace";
import FinancialDocumentsWorkspace from "components/Financial/FinancialDocumentsWorkspace";
import FinancialScorecardWorkspace from "components/Financial/FinancialScorecardWorkspace";
import FinancialSummaryWorkspace from "components/Financial/FinancialSummaryWorkspace";
import BalanceSheetWorkspace from "components/Financial/forms/BalanceSheetWorkspace";
import DebtScheduleListWorkspace from "components/Financial/forms/DebtScheduleListWorkspace";
import DebtScheduleWorkspace from "components/Financial/forms/DebtScheduleWorkspace";
import IncomeStatementWorkspace from "components/Financial/forms/IncomeStatementWorkspace";
import ScheduleFReport from "components/Financial/forms/ScheduleFReport";
import ScheduleFWorkspace from "components/Financial/forms/ScheduleFWorkspace";
import InterviewPage from "components/Financial/InterviewPage";
import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";
import { default as EmptyWorkspace } from "components/Workspaces/EmptyWorkspace";

import { EquipmentRestructuringWorkspace } from "../components/Financial/EquipmentRestructuringWorkspace";
import DebtScheduleAmortizationWorkspace from "../components/Financial/forms/DebtScheduleAmortizationWorkspace";

export const financialRoutes = [
  {
    path: "/financial",
    element: <RouteLayout />,
    children: [{ index: true, element: <EmptyWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Financial Analysis" />,
  },
  {
    path: "/financial/interview",
    element: <RouteLayout />,
    children: [{ index: true, element: <InterviewPage /> }],
    errorElement: <RouteErrorLayout errorTitle="Interview" />,
  },
  {
    path: "/financial/equipment",
    element: <RouteLayout />,
    children: [{ index: true, element: <EquipmentInventoryWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Equipment Inventory" />,
  },
  {
    path: "/financial/equipment/:equipment_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <EquipmentInventoryEditWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Equipment Inventory" />,
  },
  {
    path: "/financial/equipment/:equipment_id/:debt_schedule_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <DebtScheduleWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Debt Schedule" />,
  },
  {
    path: "/financial/equipment/:equipment_id/:debt_schedule_id/restructure",
    element: <RouteLayout />,
    children: [{ index: true, element: <EquipmentRestructuringWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Equipment Restructuring" />,
  },
  {
    path: "/financial/equipment/:equipment_id/:debt_schedule_id/:amortization_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <DebtScheduleAmortizationWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Debt Schedule" />,
  },
  {
    path: "/financial/documents",
    element: <RouteLayout />,
    children: [{ index: true, element: <FinancialDocumentsWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Financial Documents" />,
  },
  {
    path: "/financial/balance_sheet",
    element: <RouteLayout />,
    children: [{ index: true, element: <BalanceSheetWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Balance Sheet" />,
  },
  {
    path: "/financial/income_statement",
    element: <RouteLayout />,
    children: [{ index: true, element: <IncomeStatementWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Income Statement" />,
  },
  {
    path: "/financial/schedule_f",
    element: <RouteLayout />,
    children: [{ index: true, element: <ScheduleFWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Schedule F" />,
  },
  {
    path: "/financial/schedule_f_report",
    element: <RouteLayout />,
    children: [{ index: true, element: <ScheduleFReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Schedule F Report" />,
  },
  {
    path: "/financial/debt_schedule",
    element: <RouteLayout />,
    children: [{ index: true, element: <DebtScheduleListWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Debt Schedule" />,
  },
  {
    path: "/financial/debt_schedule/:debt_schedule_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <DebtScheduleWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Debt Schedule" />,
  },
  {
    path: "/financial/debt_schedule/:debt_schedule_id/restructure",
    element: <RouteLayout />,
    children: [{ index: true, element: <EquipmentRestructuringWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Equipment Restructuring" />,
  },
  {
    path: "/financial/debt_schedule/:debt_schedule_id/:amortization_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <DebtScheduleAmortizationWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Debt Schedule" />,
  },
  {
    path: "/financial/summary",
    element: <RouteLayout />,
    children: [{ index: true, element: <FinancialSummaryWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Financial Summary" />,
  },
  {
    path: "/financial/scorecard",
    element: <RouteLayout />,
    children: [{ index: true, element: <FinancialScorecardWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Financial Score Card" />,
  },
];
